import React from 'react';
import { useTheme } from '../../context/ThemeContext';

export default function Logo({ className = "" }) {
  const { theme } = useTheme();

  return (
    <div className={`flex items-center gap-1 font-black tracking-tighter text-2xl ${className}`}>
      <span className={theme === 'dark' ? 'text-orange-500' : 'text-blue-700'}>
        JW
      </span>
      <span className={theme === 'dark' ? 'text-white' : 'text-slate-700'}>
        COSTA
      </span>
    </div>
  );
}
